// extracted by mini-css-extract-plugin
export default {"chartContainer":"detail_chartContainer__VG3lc"};